import React from 'react';
import PropTypes from 'prop-types';

import { useStyles } from './integrationsSection.styles';

function Logo ({ integration }) {
    const classes = useStyles();
    const { name, logo, initials } = integration;

    return (
        <div className={classes.logo}>
            {logo
                ? <img src={logo} alt={name ? `${name} logo` : 'Integration logo'} className={classes.logoImg} />
                : <span className={classes.initials}>{initials}</span>}
        </div>
    );
}

Logo.propTypes = {
    integration: PropTypes.shape({
        name: PropTypes.string,
        logo: PropTypes.string,
        initials: PropTypes.string,
    }).isRequired,
};

export default Logo;
